
// Require

var BaseModal = require('./base-modal');


//
// Voucher Preview Modal
//

module.exports = function PreviewModal ($host, config) {

  // Base
  var base = BaseModal($host, config);

  // Setup
  var baseUrl = $('[data-base-url]').data('base-url');

  // Dom
  var $iframe = $('iframe', $host);

  // Functions
  function compileQueryString (params) {
    var pairs = [];
    for (var key in params) { pairs.push(key + '=' + params[key]); }
    return pairs.join('&');
  }

  function populate (vid, queryParams) {
    log('PreviewModal::populate', vid, queryParams);
    $iframe.attr('src', log(baseUrl + vid + '?' + queryParams));
  }

  // Interface
  return {
    invoke: function (vid, queryParams) {
      base.reveal();
      populate(vid, queryParams);
    }
  };

};

